export default "/_next/static/images/87aba126969bd9a09e65c413b0f05f8a.png";